import { Card, Col, Container, Form, Row } from "react-bootstrap";
import PieChartStatistics from "./StatisticsChart/PieChartStatistics";
import ColumnChartStatistics from "./StatisticsChart/ColumnChartStatistics";
import UserActivityLogsData from "./StatisticsTables/UserActivityLogsData";
import SitePerformanceSummaryData from "./StatisticsTables/SitePerformanceSummaryData";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeatmapChartStatistics from "./StatisticsChart/HeatmapChartStatistics";
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";

const NotificationStatisticsDataList = () => {
  const [siteHitMap, setSiteHitMap] = useState([]);
  const [siteHitMapLoader, setSiteHitMapLoader] = useState(false);
  const [chartLoader, setChartLoader] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [sitePerformanceLoader, setSitePerformanceLoader] = useState(false);
  const [sitePerformance, setSitePerformance] = useState([]);
  const [userActivityLoader, setUserActivityLoader] = useState(false);
  const [userActivity, setUserActivity] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const getStudyFormSiteWiseTotalNotification = async () => {
    setChartLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormSiteWiseTotalNotification(userData)
    setSiteList(data?.site || [])
    setNotificationList(data?.query || [])
    setChartLoader(false)
  }

  const getStudyFormSiteWiseTotalFormLevelNotification = async () => {
    setSiteHitMapLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyFormSiteWiseTotalFormLevelNotification(userData)
    setSiteHitMap(data?.data || [])
    setSiteHitMapLoader(false)
  }

  const getStudySitePerformanceNotificationSummery = async () => {
    setSitePerformanceLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudySitePerformanceNotificationSummery(userData)
    setSitePerformance(data?.data || [])
    setSitePerformanceLoader(false)
  }

  const getStudyUserActivityNotificationSummery = async () => {
    setUserActivityLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.mode = StudyMode
    let data = await studySiteDataEntryServices.getStudyUserActivityNotificationSummery(userData)
    setUserActivity(data?.data || [])
    setUserActivityLoader(false)
  }

  useEffect(() => {
    getStudyFormSiteWiseTotalNotification()
    getStudyFormSiteWiseTotalFormLevelNotification()
    getStudySitePerformanceNotificationSummery()
    getStudyUserActivityNotificationSummery()
  }, []);
  return (
    <>
      <div className="overflow-auto pt-2" style={{ height: "calc(100vh - 145px)" }}>
        <Container fluid>
          <Row>
            <Form.Group as={Col} md={12} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <HeatmapChartStatistics
                    siteHitMap={siteHitMap}
                    siteHitMapLoader={siteHitMapLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={4} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <PieChartStatistics
                    siteList={siteList}
                    notificationList={notificationList}
                    chartLoader={chartLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={8} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body className="p-0">
                  <ColumnChartStatistics
                    siteList={siteList}
                    notificationList={notificationList}
                    chartLoader={chartLoader}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={7} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body>
                  <SitePerformanceSummaryData
                    sitePerformanceLoader={sitePerformanceLoader}
                    sitePerformance={sitePerformance}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
            <Form.Group as={Col} md={5} className="mb-3">
              <Card className="bg-light shadow-sm border br3">
                <Card.Body>
                  <UserActivityLogsData
                    userActivityLoader={userActivityLoader}
                    userActivity={userActivity}
                  />
                </Card.Body>
              </Card>
            </Form.Group>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NotificationStatisticsDataList;
